export default {
      id: "url-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "img/icons.1563a6ab.svg#url",
      toString: function () {
        return this.url;
      }
    }